import { getEnumValues } from './get-enum-values';
export enum DevelopmentalAge{
	Early='Early',
	Average='Average',
	Late='Late',
	All="All",
}
export const DevelopmentalAgeValues = getEnumValues<DevelopmentalAge>(DevelopmentalAge);